import { render, staticRenderFns } from "./ChannelSwitch.vue?vue&type=template&id=3faa775e"
import script from "./ChannelSwitch.vue?vue&type=script&lang=js"
export * from "./ChannelSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports